import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const ACCESS = "re_access";
const REFRESH = "re_refresh";

export const tokens = {
  set(a: string, r?: string) {
    localStorage.setItem(ACCESS, a);
    if (r) localStorage.setItem(REFRESH, r);
  },
  clear() {
    localStorage.removeItem(ACCESS);
    localStorage.removeItem(REFRESH);
  },
  access: () => localStorage.getItem(ACCESS),
};

api.interceptors.request.use((cfg) => {
  const t = tokens.access();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing: Promise<string | null> | null = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    const skip = /\/auth\/(login|refresh)/.test(orig?.url || "");
    if (err.response?.status === 401 && orig && !orig._retry && !skip) {
      orig._retry = true;
      refreshing =
        refreshing ||
        axios
          .post(`${API}/auth/refresh`, { refresh_token: localStorage.getItem(REFRESH) }, { withCredentials: true })
          .then((r) => {
            tokens.set(r.data.access_token);
            return r.data.access_token as string;
          })
          .catch(() => null)
          .finally(() => setTimeout(() => (refreshing = null), 0));
      const t = await refreshing;
      if (t) {
        orig.headers.Authorization = `Bearer ${t}`;
        return api(orig);
      }
      tokens.clear();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message ? "সার্ভারে সমস্যা হয়েছে, আবার চেষ্টা করুন" : "কিছু ভুল হয়েছে";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
